module.exports = __webpack_public_path__ + "ed64124e694e92509b5cb95708bfd232.pdf";